// extracted by mini-css-extract-plugin
module.exports = {"spacing":"'../../styles/spacing.css'","medium-small":"12px","medium":"16px","wrapper":"Setup_wrapper__2zoEF","icon":"Setup_icon__3-lXM","capacity":"Setup_capacity__3DQq0"};